import React from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    useLocation,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

import { IStore } from 'src/types/reducers';
import Login from 'route/login';
import Logout from 'route/logout';
import NotFound from 'route/not-found';
import Profile from 'route/profile';
import Antifrod from 'route/antifrod';
import Layout from 'component/layout';
import { key as keyUser } from 'component/user/reducer';

const selectUser = (state: IStore) => state[keyUser];
const selectIsAuth = createSelector([selectUser], (user) => !!user.id);

const ProtectedRoute = ({ children }: { children: React.ReactElement }) => {
    const isAuth = useSelector(selectIsAuth);
    const location = useLocation();

    if (!isAuth) {
        return <Navigate to="/login" replace={true} state={{ from: location }} />;
    }

    return children;
};

const AppRoutes = () => {
    const isAuth = useSelector(selectIsAuth);

    return (
        <Routes>
            <Route path="/login" element={isAuth ? <Navigate to="/antifrod" /> : <Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route
                path="/"
                element={(
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                )}
            >
                <Route index={true} element={<Navigate to="/antifrod" replace={true} />} />
                <Route path="antifrod" element={<Antifrod />} />
                <Route path="profile" element={<Profile />} />
            </Route>
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace={true} />} />
        </Routes>
    );
};

const router = {
    future: {
        v7_startTransition: true,
        v7_relativeSplatPath: true
    }
    // basename: __DEVELOPMENT__ ? '/' : '/new/'
};

const RootRouter: React.FC = () => (
    <BrowserRouter {...router}>
        <AppRoutes />
    </BrowserRouter>
);

export default RootRouter;
